import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apagar from "../../assets/icons8-apagar-para-sempre-48 (2).png";
import editar from "../../assets/editar.png";
import api from "../../services/api";
import Cookies from "js-cookie";
import UsuariosPDF from "../Reports/Usuarios/usuarios";
import { ToastContainer, toast } from "react-toastify";
import { isAdmin } from "../../services/auth";
import "react-toastify/dist/ReactToastify.css";
import "../Usuario/usuarioView.scss"
import { FiFileText } from "react-icons/fi";

import Tooltip from "@mui/material/Tooltip";
import { MdDeleteForever } from "react-icons/md";
import Swal from "sweetalert2";
import { CiEdit } from "react-icons/ci";
import Preloader from "../PreloaderGrids/Preloader"
import { pdf } from "@react-pdf/renderer";
import BaseTemplate from "../Reports/GeradorPDF/BasePDFTemplate";
import { FileDown } from "lucide-react";
import { UserPlus } from "lucide-react";
import logo from "../../assets/logo.png"


function Usuario() {
  const [marcadores, setMarcadores] = useState([]);
  const [pages, setPages] = useState([]);
  const [marc, setMot] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [isAdminState, setIsAdminState] = useState(false);
  const [selecionados, setSelecionados] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toggleSelecionado = (id) => {
    setSelecionados((prevSelecionados) => (prevSelecionados.includes(id) ? prevSelecionados.filter((item) => item !== id) : [...prevSelecionados, id]));
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [buscaVeiculo, setBuscaVeiculo] = useState("");


  //=========================
  //CONFIRMAÇÃO DE CADASTRO
  //=========================

  const confirmarCadastro = async () => {
    const result = await Swal.fire({
      width: "500px",
      padding: "0",
      background: "#0f172a",
      color: "#ffffff",

      html: `
      <div class="confirmar-cadastro-modal">

        <div class="confirmar-cadastro-header">

          <div class="confirmar-cadastro-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="16" y1="11" x2="22" y2="11" />
            </svg>
          </div>

          <div>
            <h2>Novo usuário</h2>

            <span>
              Confirme para continuar
            </span>
          </div>

        </div>


        <div class="confirmar-cadastro-content">

          <div class="confirmar-cadastro-text">

            Você será redirecionado para a tela
            de cadastro de usuários.

          </div>


          <div class="confirmar-cadastro-info">

            <div class="confirmar-cadastro-info-icon">

              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>

            </div>

            <span>
              Após confirmar, você poderá preencher
              os dados do novo usuário.
            </span>

          </div>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Continuar",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#147fc1",

      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      customClass: {
        popup: "swal-confirmar-cadastro",

        actions: "swal-confirmar-cadastro-actions",

        confirmButton: "swal-confirmar-cadastro-confirm",

        cancelButton: "swal-confirmar-cadastro-cancel"
      }
    });

    if (!result.isConfirmed) return;

    navigate("/maps/cadastro-usuarios");
  };








  //=======================
  // CONFIRMAÇÃO DE EDIÇÃO
  //=======================
  const confirmarEdicao = async (usuario) => {
    const result = await Swal.fire({
      width: "520px",
      padding: "0",
      background: "#0f172a",
      color: "#ffffff",

      html: `
      <div class="confirmar-edicao-usuario-modal">

        <div class="confirmar-edicao-usuario-header">

          <div class="confirmar-edicao-usuario-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
          </div>

          <div>
            <h2>Editar usuário</h2>

            <span>
              Confira os dados antes de continuar
            </span>
          </div>

        </div>


        <div class="confirmar-edicao-usuario-content">

          <div class="confirmar-edicao-usuario-text">

            Você está prestes a editar os dados
            deste usuário.

          </div>


          <div class="confirmar-edicao-usuario-box">

            <div class="confirmar-edicao-usuario-item">

              <span class="confirmar-edicao-usuario-label">
                Nome
              </span>

              <strong>
                ${usuario.nome || "-"}
              </strong>

            </div>


            <div class="confirmar-edicao-usuario-item">

              <span class="confirmar-edicao-usuario-label">
                Nível de acesso
              </span>

              <strong>
                ${usuario.tipo === "a"
          ? "Administrador"
          : "Usuário"
        }
              </strong>

            </div>

          </div>


          <div class="confirmar-edicao-usuario-info">

            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>

            <span>
              Você poderá alterar os dados do usuário
              na próxima tela.
            </span>

          </div>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Editar usuário",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#147fc1",

      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      customClass: {
        popup: "swal-confirmar-edicao-usuario",

        actions: "swal-confirmar-edicao-usuario-actions",

        confirmButton: "swal-confirmar-edicao-usuario-confirm",

        cancelButton: "swal-confirmar-edicao-usuario-cancel"
      }
    });

    if (!result.isConfirmed) return;

    navigate(`/maps/editar-usuario/${usuario.id}`);
  };







  const confirmarPDF = async () => {
    // =========================================================
    // VALIDAR REGISTROS
    // =========================================================

    if (!marcadores || marcadores.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhum registro",
        text: "Não há usuários para gerar o PDF.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#f59e0b",
      });

      return;
    }

    // =========================================================
    // USUÁRIOS QUE SERÃO ENVIADOS PARA O PDF
    // =========================================================

    const usuariosPDF = marcadores;

    console.log("=================================");
    console.log("GERAÇÃO DE PDF - USUÁRIOS");
    console.log("Usuários:", usuariosPDF);
    console.log("Quantidade:", usuariosPDF.length);
    console.log("=================================");

    // =========================================================
    // CONFIRMAÇÃO
    // =========================================================

    const result = await Swal.fire({
      html: `
      <div class="swal-pdf-content">

        <div class="swal-pdf-question">
          ?
        </div>

        <div class="swal-pdf-heading">
          Gerar PDF?
        </div>

        <p class="swal-pdf-subtitle">
          Você está prestes a gerar um relatório com:
        </p>

        <div class="swal-pdf-count">
          ${usuariosPDF.length}
        </div>

        <div class="swal-pdf-label">
          ${usuariosPDF.length === 1 ? "usuário" : "usuários"}
        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Sim, gerar",
      cancelButtonText: "Cancelar",

      reverseButtons: true,

      buttonsStyling: false,

      customClass: {
        popup: "swal-pdf-popup",
        htmlContainer: "swal-pdf-html",
        actions: "swal-pdf-actions",
        confirmButton: "swal-pdf-confirm",
        cancelButton: "swal-pdf-cancel",
      },
    });

    // =========================================================
    // CANCELADO
    // =========================================================

    if (!result.isConfirmed) {
      return;
    }

    // =========================================================
    // TOKEN
    // =========================================================

    const token = localStorage.getItem("id");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Cliente não identificado",
        text: "Não foi possível identificar o cliente.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#ef4444",
      });

      return;
    }

    // =========================================================
    // ABRIR NOVA ABA
    // =========================================================

    const novaAba = window.open("", "_blank");

    if (!novaAba) {
      Swal.fire({
        icon: "warning",
        title: "Nova aba bloqueada",
        text: "Permita pop-ups para visualizar o relatório.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#f59e0b",
      });

      return;
    }

    // =========================================================
    // LOADING DENTRO DA NOVA ABA
    // =========================================================

    novaAba.document.write(`
    <!DOCTYPE html>

    <html lang="pt-BR">

    <head>

      <meta charset="UTF-8">

      <title>
        Gerando relatório...
      </title>

      <style>

        * {
          box-sizing: border-box;
        }

        html,
        body {
          margin: 0;
          width: 100%;
          height: 100%;

          font-family:
            Arial,
            Helvetica,
            sans-serif;

          background: #0b1220;
        }

        body {
          display: flex;

          align-items: center;
          justify-content: center;
        }

        .loading-container {

          width: 380px;

          padding: 42px 35px;

          text-align: center;

          border-radius: 18px;

          background:
            linear-gradient(
              145deg,
              #111c2d,
              #0d1726
            );

          border:
            1px solid
            rgba(255,255,255,.08);

          box-shadow:
            0 25px 70px
            rgba(0,0,0,.45);
        }

        .spinner {

          width: 48px;
          height: 48px;

          margin: 0 auto 25px;

          border-radius: 50%;

          border:
            3px solid
            rgba(255,255,255,.10);

          border-top-color:
            #0b73b5;

          animation:
            spin .8s linear infinite;
        }

        @keyframes spin {

          to {
            transform:
              rotate(360deg);
          }

        }

        .title {

          font-size: 20px;

          font-weight: 700;

          color: #ffffff;

          margin-bottom: 8px;
        }

        .text {

          font-size: 13px;

          color: #94a3b8;

          line-height: 1.5;
        }

        .brand {

          margin-top: 25px;

          font-size: 10px;

          color: #4d87ad;

          letter-spacing: 1.2px;

          text-transform: uppercase;
        }

      </style>

    </head>

    <body>

      <div class="loading-container">

        <div class="spinner"></div>

        <div class="title">
          Gerando relatório
        </div>

        <div class="text">
          Estamos preparando seu PDF.<br>
          Isso pode levar alguns segundos...
        </div>

        <div class="brand">
          Relatório de Usuários
        </div>

      </div>

    </body>

    </html>
  `);

    novaAba.document.close();

    // =========================================================
    // FORM POST
    // =========================================================

    const form =
      novaAba.document.createElement("form");

    form.method = "POST";

    form.action =
      `${api.defaults.baseURL}/usuarioPDF`;

    form.style.display = "none";

    // =========================================================
    // TOKEN
    // =========================================================

    const inputToken =
      novaAba.document.createElement("input");

    inputToken.type = "hidden";

    inputToken.name = "token";

    inputToken.value = token;

    form.appendChild(inputToken);

    // =========================================================
    // USUÁRIOS DA PÁGINA ATUAL
    // =========================================================

    const inputUsuarios =
      novaAba.document.createElement("input");

    inputUsuarios.type = "hidden";

    inputUsuarios.name = "usuarios";

    inputUsuarios.value =
      JSON.stringify(usuariosPDF);

    form.appendChild(inputUsuarios);

    // =========================================================
    // QUANTIDADE
    // =========================================================

    const inputQuantidade =
      novaAba.document.createElement("input");

    inputQuantidade.type = "hidden";

    inputQuantidade.name = "quantidade";

    inputQuantidade.value =
      usuariosPDF.length;

    form.appendChild(inputQuantidade);

    // =========================================================
    // DEBUG
    // =========================================================

    console.log("=================================");
    console.log("POST /usuarioPDF");
    console.log("Token:", token);
    console.log("Quantidade:", usuariosPDF.length);
    console.log("Usuários enviados:", usuariosPDF);
    console.log(
      "JSON:",
      JSON.stringify(usuariosPDF)
    );
    console.log("=================================");

    // =========================================================
    // ADICIONAR FORM NA NOVA ABA
    // =========================================================

    novaAba.document.body.appendChild(form);

    // =========================================================
    // ENVIAR
    // =========================================================

    form.submit();

    // =========================================================
    // LOADING NO SISTEMA
    // =========================================================

    Swal.fire({
      html: `
      <div class="swal-pdf-loading">

        <div class="swal-pdf-loading-spinner"></div>

        <div class="swal-pdf-loading-title">
          Gerando PDF
        </div>

        <div class="swal-pdf-loading-text">
          Preparando seu relatório...
        </div>

      </div>
    `,

      allowOutsideClick: false,
      allowEscapeKey: false,

      showConfirmButton: false,

      timer: 900,

      customClass: {
        popup: "swal-pdf-loading-popup",
        htmlContainer: "swal-pdf-loading-html",
      },
    });
  };













  // Verifica se é admin
  useEffect(() => {
    const checkAdmin = async () => {
      const response = await isAdmin();
      setIsAdminState(response.status === "success" && response.isAdmin);
    };
    checkAdmin();
  }, []);










  // =======================
  // EXCLUIR SELECIONADO
  //========================
  const excluirSelecionados = async () => {
    if (selecionados.length === 0) return;

    // ============================================================
    // USUÁRIO LOGADO
    // ============================================================

    const usuarioLogadoId = Number(localStorage.getItem("clientID"));

    // ============================================================
    // SEPARA:
    // - usuários que podem ser excluídos
    // - usuário logado, que NÃO pode ser excluído
    // ============================================================

    const idsBloqueados = selecionados.filter(
      (id) => Number(id) === usuarioLogadoId
    );

    const idsPermitidos = selecionados.filter(
      (id) => Number(id) !== usuarioLogadoId
    );

    // ============================================================
    // TENTOU EXCLUIR O PRÓPRIO USUÁRIO
    // ============================================================

    if (idsBloqueados.length > 0) {
      const usuarioLogado = marcadores.find(
        (u) => Number(u.id) === usuarioLogadoId
      );

      await Swal.fire({
        width: "440px",
        padding: "0",
        background: "#0f172a",
        color: "#ffffff",

        html: `
        <div style="
          padding: 28px 26px 24px;
          text-align: center;
        ">

          <div style="
            width: 58px;
            height: 58px;
            margin: 0 auto 18px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(245, 158, 11, 0.10);
            border: 1px solid rgba(245, 158, 11, 0.20);
            color: #f59e0b;
          ">

            <svg
              width="27"
              height="27"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>

          </div>

          <div style="
            font-size: 19px;
            font-weight: 600;
            color: #f9fafb;
            margin-bottom: 9px;
          ">
            Ação não permitida
          </div>

          <div style="
            font-size: 14px;
            line-height: 1.6;
            color: #94a3b8;
          ">
            Você não pode excluir o usuário que está
            atualmente logado.
          </div>

          ${usuarioLogado
            ? `
                <div style="
                  margin-top: 16px;
                  padding: 11px 14px;
                  border-radius: 8px;
                  background: rgba(255,255,255,0.03);
                  border: 1px solid rgba(255,255,255,0.06);
                  color: #e2e8f0;
                  font-size: 13px;
                ">
                  <b>${usuarioLogado.nome || "Usuário atual"}</b>
                </div>
              `
            : ""
          }

        </div>
      `,

        confirmButtonText: "Entendi",
        confirmButtonColor: "#3b82f6",
      });

      // ============================================================
      // SE SELECIONOU SOMENTE O PRÓPRIO USUÁRIO
      // NÃO CONTINUA
      // ============================================================

      if (idsPermitidos.length === 0) {
        return;
      }
    }

    // ============================================================
    // USUÁRIOS QUE REALMENTE SERÃO EXCLUÍDOS
    // ============================================================

    const usuariosParaExcluir = marcadores.filter((u) =>
      idsPermitidos.includes(u.id)
    );

    // ============================================================
    // HTML DA LISTA
    // ============================================================

    const usuariosSelecionados = usuariosParaExcluir
      .map((u) => {
        return `
        <div style="
          border:none;
          border-radius:8px;
          padding:10px;
          margin-bottom:10px;
          background:none;
          text-align:left;
        ">

          <p>
            <b>Nome do usuário:</b>
            ${u.nome || "-"}
          </p>

          <p>
            <b>Nível de acesso:</b>
            ${u.tipo === "a"
            ? "Administrador"
            : "Usuário"
          }
          </p>

        </div>
      `;
      })
      .join("");

    // ============================================================
    // MODAL DE CONFIRMAÇÃO
    // ============================================================

    const result = await Swal.fire({
      width: "560px",
      padding: "0",
      background: "#0f172a",
      color: "#ffffff",

      html: `
      <div class="excluir-usuarios-modal">

        <div class="excluir-usuarios-header">

          <div class="excluir-usuarios-icon">

            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6" />
              <path d="M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>

          </div>

          <div>

            <h2>Excluir usuários</h2>

            <span>
              Confirme os usuários antes de continuar
            </span>

          </div>

        </div>

        <div class="excluir-usuarios-content">

          <div class="excluir-usuarios-text">

            Você está prestes a excluir

            <strong>
              ${idsPermitidos.length}
            </strong>

            ${idsPermitidos.length === 1
          ? "usuário"
          : "usuários"
        }.

          </div>

          <div class="excluir-usuarios-box">

            <div class="excluir-usuarios-label">
              Usuários selecionados
            </div>

            <div class="excluir-usuarios-lista">
              ${usuariosSelecionados}
            </div>

          </div>

          ${idsBloqueados.length > 0
          ? `
                <div style="
                  margin-top: 12px;
                  padding: 11px 13px;
                  border-radius: 8px;
                  background: rgba(245,158,11,0.08);
                  border: 1px solid rgba(245,158,11,0.15);
                  color: #fbbf24;
                  font-size: 13px;
                  text-align: left;
                  line-height: 1.5;
                ">
                  <b>Atenção:</b>
                  o usuário atualmente logado foi removido
                  da seleção e não será excluído.
                </div>
              `
          : ""
        }

          <div class="excluir-usuarios-aviso">

            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line
                x1="12"
                y1="8"
                x2="12.01"
                y2="8"
              />
              <line
                x1="12"
                y1="12"
                x2="12"
                y2="16"
              />
            </svg>

            <span>
              Essa ação não poderá ser desfeita.
            </span>

          </div>

        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Excluir usuários",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#dc2626",

      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      customClass: {
        popup: "swal-excluir-usuarios",

        actions: "swal-excluir-usuarios-actions",

        confirmButton: "swal-excluir-usuarios-confirm",

        cancelButton: "swal-excluir-usuarios-cancel",
      },
    });

    // ============================================================
    // CANCELADO
    // ============================================================

    if (!result.isConfirmed) {
      return;
    }

    // ============================================================
    // PROCESSO DE EXCLUSÃO
    // ============================================================

    try {
      // ============================================================
      // LOADING
      // ============================================================

      Swal.fire({
        width: "420px",
        padding: "0",
        background: "#0f172a",
        color: "#ffffff",

        html: `
        <div class="removendo-usuarios-modal">

          <div class="removendo-usuarios-header">

            <div class="removendo-usuarios-icon">

              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 12a9 9 0 1 1-2.64-6.36" />
                <polyline points="21 3 21 9 15 9" />
              </svg>

            </div>

            <div>

              <h2>Removendo usuários</h2>

              <span>
                Processando exclusão no sistema
              </span>

            </div>

          </div>

          <div class="removendo-usuarios-content">

            <div class="removendo-usuarios-loader">

              <div class="removendo-usuarios-spinner"></div>

            </div>

            <div
              id="swal-status"
              class="removendo-usuarios-status"
            >
              Iniciando remoção...
            </div>

            <div class="removendo-usuarios-info">

              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >

                <circle cx="12" cy="12" r="10" />

                <line
                  x1="12"
                  y1="8"
                  x2="12"
                  y2="12"
                />

                <line
                  x1="12"
                  y1="16"
                  x2="12.01"
                  y2="16"
                />

              </svg>

              <span>
                Não feche esta janela enquanto a operação estiver em andamento.
              </span>

            </div>

          </div>

        </div>
      `,

        showConfirmButton: false,

        allowOutsideClick: false,

        allowEscapeKey: false,

        customClass: {
          popup: "swal-removendo-usuarios",
        },
      });

      // ============================================================
      // EXCLUSÃO DOS USUÁRIOS
      // ============================================================

      for (let i = 0; i < idsPermitidos.length; i++) {

        const id = idsPermitidos[i];

        const usuario = usuariosParaExcluir.find(
          (u) => Number(u.id) === Number(id)
        );

        // ==========================================================
        // ATUALIZA STATUS
        // ==========================================================

        const status =
          document.getElementById("swal-status");

        if (status) {
          status.innerHTML = `
          Removendo usuário
          <b>${i + 1}</b>
          de
          <b>${idsPermitidos.length}</b>

          <br/>

          <span style="
            color:#94a3b8;
            font-size:13px;
          ">
            ${usuario?.nome || ""}
          </span>
        `;
        }

        // ==========================================================
        // SEGURANÇA EXTRA
        // ==========================================================
        // Mesmo que alguma coisa tenha passado pelo filtro,
        // nunca envia o ID do usuário logado para a API.

        if (Number(id) === usuarioLogadoId) {
          console.warn(
            "Tentativa de excluir usuário logado bloqueada:",
            id
          );

          continue;
        }

        // ==========================================================
        // REMOVE USUÁRIO
        // ==========================================================

        await api.put(`usuarios/${id}`, {
          ativo: id,
          awsd: Cookies.get("2353138890"),
          apagado_por: localStorage.getItem("clientID"),
        });

        // ==========================================================
        // DELAY VISUAL
        // ==========================================================

        await new Promise((resolve) =>
          setTimeout(resolve, 2500)
        );
      }

      // ============================================================
      // FINALIZA
      // ============================================================

      Swal.fire({
        background: "#111827",
        color: "#f9fafb",

        width: 420,

        html: `
        <div style="
          display:flex;
          flex-direction:column;
          align-items:center;
          padding-top:10px;
        ">

          <div style="
            width:58px;
            height:58px;
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content:center;
            background:rgba(34,197,94,0.10);
            border:1px solid rgba(34,197,94,0.20);
          ">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#22c55e"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6L9 17l-5-5"/>
            </svg>

          </div>

          <div style="
            margin-top:18px;
            font-size:18px;
            font-weight:600;
            color:#f9fafb;
          ">
            Usuários removidos
          </div>

          <div style="
            margin-top:8px;
            color:#94a3b8;
            font-size:14px;
            text-align:center;
            line-height:1.6;
          ">
            A remoção foi concluída com sucesso.
          </div>

        </div>
      `,

        timer: 2200,

        showConfirmButton: false,

        customClass: {
          popup: "rounded-4",
        },
      });

      // ============================================================
      // LIMPA SELEÇÃO
      // ============================================================

      setSelecionados([]);

      atualizarPaginacao();

    } catch (error) {

      // ============================================================
      // ERRO
      // ============================================================

      Swal.fire({
        background: "#111827",
        color: "#f9fafb",

        width: 420,

        html: `
        <div style="
          display:flex;
          flex-direction:column;
          align-items:center;
          padding-top:10px;
        ">

          <div style="
            width:58px;
            height:58px;
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content:center;
            background:rgba(239,68,68,0.10);
            border:1px solid rgba(239,68,68,0.18);
          ">

            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ef4444"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
              />

              <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
              />
            </svg>

          </div>

          <div style="
            margin-top:18px;
            font-size:18px;
            font-weight:600;
            color:#f9fafb;
          ">
            Falha na remoção
          </div>

          <div style="
            margin-top:8px;
            color:#94a3b8;
            font-size:14px;
            text-align:center;
            line-height:1.6;
          ">
            Não foi possível excluir os usuários selecionados.
          </div>

        </div>
      `,

        confirmButtonText: "Fechar",

        confirmButtonColor: "#ef4444",

        customClass: {
          popup: "rounded-4",
        },
      });

      console.error(error);
    }
  };





  //======================
  //PRELOADER | DADOS 
  //======================
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const atualizarPaginacao = useCallback(async () => {

    const isFirstLoad = showLoader;
    const start = Date.now();

    // Loader principal
    if (isFirstLoad) {
      setLoading(true);
    }

    //  Loader paginação
    if (!isFirstLoad) {
      setLoadingPage(true);
    }

    try {

      // ==========================
      //  Buscar total de registros
      // ==========================
      const { data: totalData } = await api.get(
        `/totalusuario?searchTerm=${searchTerm}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        }


      );

      const total = totalData.result;
      setTotalItems(total);
      console.log(totalData)

      const totalPages = Math.ceil(total / limit);
      setPages(Array.from({ length: totalPages }, (_, i) => i + 1));

      let paginaCorrigida =
        currentPage > totalPages ? totalPages || 1 : currentPage;

      setCurrentPage(paginaCorrigida);

      // ==========================
      //  Buscar dados da página
      // ==========================
      const { data } = await api.get(
        `/usuariopages?limit=${limit}&page=${paginaCorrigida}&searchTerm=${encodeURIComponent(searchTerm)}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        }
      );

      setMarcadores(data.usuario.data);

    } catch (error) {
      console.error("Erro ao atualizar paginação:", error);
      toast.error("Erro ao buscar usuários");
    } finally {

      const elapsed = Date.now() - start;

      // Loader principal (tempo maior)
      if (isFirstLoad) {
        const MIN_DELAY = 5000;

        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed);
        }

        setLoading(false);
        await delay(1000);
        setShowLoader(false);
      }

      // Loader paginação (tempo menor)
      if (!isFirstLoad) {
        const MIN_DELAY_PAGE = 2500;

        if (elapsed < MIN_DELAY_PAGE) {
          await delay(MIN_DELAY_PAGE - elapsed);
        }

        setLoadingPage(false);
      }
    }

  }, [searchTerm, limit, currentPage, showLoader]);






  useEffect(() => {
    atualizarPaginacao();
  }, [limit, currentPage, searchTerm]);

  const handlePagination = (page) => {
    if (page >= 1 && page <= pages.length) {
      setCurrentPage(page);
    }
  };




  //=================================
  //LIMITES POR PAGINAS SELECT BOTAO
  //==================================
  const limits = useCallback((e) => {
    setLoadingPage(true)
    setLimit(parseInt(e.target.value, 10));
    setCurrentPage(1);
  }, []);





  const getVisiblePages = (currentPage, totalPages) => {
    const pages = [];
    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 2) pages.push(1, 2, "...", totalPages);
      else if (currentPage >= totalPages - 1) pages.push(1, "...", totalPages - 1, totalPages);
      else pages.push(1, "...", currentPage, "...", totalPages);
    }
    return pages;
  };


  //=========================
  // MOSTRAR GRUPOS DO USUÁRIO
  //=========================
 
const mostrarGrupos = (gruposNomes) => {
  const grupos = gruposNomes
    .split(",")
    .map((grupo) => grupo.trim())
    .filter(Boolean);

  const escaparHTML = (valor) =>
    String(valor).replace(/[&<>"']/g, (caractere) => {
      const entidades = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };

      return entidades[caractere];
    });

  Swal.fire({
    title: "Grupos do usuário",
    width: "640px",
    background: "#f8fafc",
    color: "#304858",

    html: `
      <div class="usuarios-ui-grupos-modal">

        <div class="usuarios-ui-grupos-description">
          Consulte e pesquise os grupos vinculados a este usuário.
        </div>

        <div class="usuarios-ui-grupos-search">
          <span class="usuarios-ui-grupos-search-icon">⌕</span>

          <input
            type="search"
            id="usuarios-ui-grupos-search-input"
            placeholder="Pesquisar por nome do grupo..."
            autocomplete="off"
            aria-label="Pesquisar grupos"
          />

          <span
            id="usuarios-ui-grupos-count"
            class="usuarios-ui-grupos-count"
          >
            ${grupos.length} ${grupos.length === 1 ? "grupo" : "grupos"}
          </span>
        </div>

        <div
          id="usuarios-ui-grupos-results"
          class="usuarios-ui-grupos-results"
        >
          ${grupos
            .map(
              (grupo, index) => `
                <div
                  class="usuarios-ui-grupo-item"
                  data-grupo="${escaparHTML(grupo.toLocaleLowerCase("pt-BR"))}"
                >
                  <span class="usuarios-ui-grupo-number">
                    ${String(index + 1).padStart(2, "0")}
                  </span>

                  <span class="usuarios-ui-grupo-name">
                    ${escaparHTML(grupo)}
                  </span>
                </div>
              `
            )
            .join("")}
        </div>

        <div
          id="usuarios-ui-grupos-empty"
          class="usuarios-ui-grupos-empty"
          style="display:none"
        >
          Nenhum grupo encontrado para essa pesquisa.
        </div>

      </div>
    `,

    confirmButtonText: "Fechar",
    showConfirmButton: true,
    buttonsStyling: false,

    customClass: {
      popup: "usuarios-ui-grupos-popup",
      title: "usuarios-ui-grupos-title",
      htmlContainer: "usuarios-ui-grupos-html",
      confirmButton: "usuarios-ui-grupos-confirm",
    },

    scrollbarPadding: false,

    didOpen: () => {
      const input = document.getElementById(
        "usuarios-ui-grupos-search-input"
      );

      const itens = document.querySelectorAll(
        ".usuarios-ui-grupo-item"
      );

      const contador = document.getElementById(
        "usuarios-ui-grupos-count"
      );

      const vazio = document.getElementById(
        "usuarios-ui-grupos-empty"
      );

      if (!input || !contador || !vazio) return;

      const atualizarResultados = () => {
        const busca = input.value
          .trim()
          .toLocaleLowerCase("pt-BR");

        let encontrados = 0;

        itens.forEach((item) => {
          const nome = item.dataset.grupo || "";
          const corresponde = nome.includes(busca);

          item.style.display = corresponde ? "flex" : "none";

          if (corresponde) encontrados++;
        });

        contador.textContent =
          `${encontrados} ${encontrados === 1 ? "grupo encontrado" : "grupos encontrados"}`;

        vazio.style.display = encontrados === 0 ? "flex" : "none";
      };

      input.addEventListener("input", atualizarResultados);
      input.focus();
    },
  });
};



  return (
    <>
      <ToastContainer />
      <Preloader
        customClass="laoder-alerta"
        show={loading}
        text="Carregando usuários..."
      />

      <div className="usuarios-page">
        <section className="usuarios-ui-panel">

          {/* CABEÇALHO */}
          <header className="usuarios-ui-header">
            <div className="usuarios-ui-heading">
              <div className="usuarios-ui-heading-icon">
                <UserPlus size={21} />
              </div>

              <div className="usuarios-ui-heading-text">
                <h1 className="usuarios-ui-title">Usuários</h1>
                <p className="usuarios-ui-subtitle">
                  Gerencie os usuários cadastrados, seus acessos e permissões
                </p>
              </div>
            </div>



            <button
              type="button"
              className="usuarios-ui-close"
              onClick={() => navigate(-1)}
              aria-label="Fechar usuários"
              title="Fechar"
            >
              ✕
            </button>
          </header>

          {/* BARRA DE PESQUISA E AÇÕES */}
          <div className="usuarios-ui-toolbar">

            <div className="usuarios-ui-search">
              <span className="usuarios-ui-search-icon">
                <icon name="search" size="17px" />
              </span>

              <input
                type="text"
                placeholder="Buscar usuário..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-label="Buscar usuário"
              />

              {searchTerm && (
                <button
                  type="button"
                  className="usuarios-ui-search-clear"
                  onClick={() => setSearchTerm("")}
                  title="Limpar pesquisa"
                  aria-label="Limpar pesquisa"
                >
                  ×
                </button>
              )}
            </div>

            <div className="usuarios-ui-toolbar-actions">

              <button
                type="button"
                className="usuarios-ui-action usuarios-ui-action-primary"
                onClick={confirmarPDF}
              >
                <FiFileText size={16} />
                <span>Gerar PDF</span>
              </button>

              <button
                type="button"
                className="usuarios-ui-action usuarios-ui-action-secondary"
                onClick={confirmarCadastro}
              >
                <UserPlus size={17} />
                <span>Novo usuário</span>
              </button>
            </div>
          </div>

          {/* TABELA */}
          <main className="usuarios-ui-main">

            <div className="usuarios-ui-table-scroll">
              <table className="usuarios-ui-table">
                <img src={logo} className="logo"></img>
                <thead>
                  <tr>
                    <th className="usuarios-ui-col-name">Nome</th>
                    <th className="usuarios-ui-col-level">Nível de acesso</th>
                    <th className="usuarios-ui-col-vehicles">Veículos</th>
                    <th className="usuarios-ui-col-groups">Grupos</th>

                    {isAdminState && (
                      <th className="usuarios-ui-col-actions">
                        <label
                          className="usuarios-ui-checkbox"
                          title="Selecionar todos os usuários desta lista"
                        >
                          <input
                            type="checkbox"
                            checked={
                              marcadores.length > 0 &&
                              selecionados.length === marcadores.length
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                const todosIds = marcadores.map((m) => m.id);
                                setSelecionados(todosIds);
                              } else {
                                setSelecionados([]);
                              }
                            }}
                            aria-label="Selecionar todos os usuários"
                          />
                          <span className="usuarios-ui-checkmark" />
                        </label>
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {marcadores.length > 0 ? (
                    marcadores.map((marcador) => (
                      <tr key={marcador.id}>
                        {/* NOME */}
                        <td className="usuarios-ui-name">
                          {marcador.nome || (
                            <span className="usuarios-ui-empty-value">
                              Não possui nome cadastrado
                            </span>
                          )}
                        </td>

                        {/* NÍVEL DE ACESSO */}
                        <td>
                          <span
                            className={`usuarios-ui-role ${marcador.tipo === "a"
                                ? "usuarios-ui-role-admin"
                                : "usuarios-ui-role-user"
                              }`}
                          >
                            {marcador.tipo === "a"
                              ? "Administrador"
                              : "Usuário"}
                          </span>
                        </td>

                        {/* VEÍCULOS */}
                        <td className="usuarios-ui-vehicles">
                          {marcador.veiculos ? (
                            (() => {
                              const veiculosFormatado = marcador.veiculos
                                .replace(/'/g, "")
                                .replace(/,/g, " | ");

                              return (
                                <div className="usuarios-ui-cell-content">
                                  <span className="usuarios-ui-cell-text">
                                    {veiculosFormatado.length > 50
                                      ? `${veiculosFormatado.substring(0, 50)}...`
                                      : veiculosFormatado}
                                  </span>


                                  {veiculosFormatado.length > 50 && (
                                    <button
                                      type="button"
                                      className="usuarios-ui-veiculos-open"
                                      onClick={() => {
                                        const veiculos = veiculosFormatado
                                          .split("|")
                                          .map((veiculo) => veiculo.trim())
                                          .filter(Boolean);

                                        const escaparHTML = (valor) =>
                                          String(valor).replace(/[&<>"']/g, (caractere) => {
                                            const entidades = {
                                              "&": "&amp;",
                                              "<": "&lt;",
                                              ">": "&gt;",
                                              '"': "&quot;",
                                              "'": "&#039;",
                                            };

                                            return entidades[caractere];
                                          });

                                        Swal.fire({
                                          title: "Veículos cadastrados",
                                          width: "640px",
                                          background: "#f8fafc",
                                          color: "#304858",
                                          html: `
          <div class="usuarios-ui-veiculos-modal">
            <div class="usuarios-ui-veiculos-description">
              Consulte e pesquise os veículos vinculados a este usuário.
            </div>

            <div class="usuarios-ui-veiculos-search">
              <span class="usuarios-ui-veiculos-search-icon">⌕</span>
              <input
                id="usuarios-ui-veiculos-search-input"
                type="search"
                placeholder="Pesquisar por placa..."
                autocomplete="off"
                aria-label="Pesquisar veículos por placa"
              />
              <span
                id="usuarios-ui-veiculos-count"
                class="usuarios-ui-veiculos-count"
              >
                ${veiculos.length} veículos
              </span>
            </div>

            <div
              id="usuarios-ui-veiculos-results"
              class="usuarios-ui-veiculos-results"
            >
              ${veiculos
                                              .map(
                                                (veiculo) => `
                    <div
                      class="usuarios-ui-veiculo-item"
                      data-placa="${escaparHTML(veiculo.toLowerCase())}"
                    >
                      <span class="usuarios-ui-veiculo-indicator"></span>
                      <span class="usuarios-ui-veiculo-placa">
                        ${escaparHTML(veiculo)}
                      </span>
                    </div>
                  `
                                              )
                                              .join("")}
            </div>

            <div
              id="usuarios-ui-veiculos-empty"
              class="usuarios-ui-veiculos-empty"
              style="display:none"
            >
              Nenhum veículo encontrado para essa pesquisa.
            </div>
          </div>
        `,
                                          showConfirmButton: true,
                                          confirmButtonText: "Fechar",
                                          confirmButtonColor: "#287db5",
                                          customClass: {
                                            popup: "usuarios-ui-veiculos-popup",
                                            title: "usuarios-ui-veiculos-title",
                                            htmlContainer: "usuarios-ui-veiculos-html",
                                            confirmButton: "usuarios-ui-veiculos-confirm",
                                          },
                                          scrollbarPadding: false,
                                          didOpen: () => {
                                            const input = document.getElementById(
                                              "usuarios-ui-veiculos-search-input"
                                            );
                                            const itens = document.querySelectorAll(
                                              ".usuarios-ui-veiculo-item"
                                            );
                                            const contador = document.getElementById(
                                              "usuarios-ui-veiculos-count"
                                            );
                                            const vazio = document.getElementById(
                                              "usuarios-ui-veiculos-empty"
                                            );

                                            const atualizarResultados = () => {
                                              const termo = input.value
                                                .trim()
                                                .toLowerCase();

                                              let encontrados = 0;

                                              itens.forEach((item) => {
                                                const corresponde = item.dataset.placa.includes(termo);

                                                item.style.display = corresponde ? "flex" : "none";

                                                if (corresponde) encontrados++;
                                              });

                                              contador.textContent =
                                                `${encontrados} ${encontrados === 1 ? "veículo" : "veículos"}`;

                                              vazio.style.display =
                                                encontrados === 0 ? "flex" : "none";
                                            };

                                            input.addEventListener("input", atualizarResultados);
                                            input.focus();
                                          },
                                        });
                                      }}
                                    >
                                      Ler mais
                                    </button>
                                  )}

                                </div>
                              );
                            })()
                          ) : (
                            <span className="usuarios-ui-empty-value">
                              Não possui veículos cadastrados
                            </span>
                          )}
                        </td>

                        {/* GRUPOS */}
                        <td className="usuarios-ui-groups">
                          {marcador.grupos_nomes
                            ? (() => {
                              const grupos = marcador.grupos_nomes
                                .split(", ")
                                .filter(Boolean);

                              const temMais = grupos.length > 5;

                              return (
                                <div className="usuarios-ui-cell-content">
                                  <span className="usuarios-ui-cell-text">
                                    {grupos.slice(0, 5).join(", ")}
                                  </span>

                                  {temMais && (
                                    <button
                                      type="button"
                                      className="usuarios-ui-read-more"
                                      onClick={() =>
                                        mostrarGrupos(marcador.grupos_nomes)
                                      }
                                    >
                                      Ler mais
                                    </button>
                                  )}
                                </div>
                              );
                            })()
                            : (
                              <span className="usuarios-ui-empty-value">
                                Não possui grupos cadastrados
                              </span>
                            )}
                        </td>

                        {/* AÇÕES ADMINISTRATIVAS */}
                        {isAdminState && (
                          <td className="usuarios-ui-actions-cell">
                            <div className="usuarios-ui-row-actions">
                              <Tooltip
                                title="Editar usuário"
                                arrow
                                placement="bottom"
                              >
                                <button
                                  type="button"
                                  className="usuarios-ui-edit"
                                  onClick={() => confirmarEdicao(marcador)}
                                  aria-label={`Editar ${marcador.nome || "usuário"}`}
                                >
                                  <CiEdit size={21} />
                                </button>
                              </Tooltip>

                              <label
                                className="usuarios-ui-checkbox"
                                title="Selecionar usuário"
                              >
                                <input
                                  type="checkbox"
                                  checked={selecionados.includes(marcador.id)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelecionados([
                                        ...selecionados,
                                        marcador.id,
                                      ]);
                                    } else {
                                      setSelecionados(
                                        selecionados.filter(
                                          (id) => id !== marcador.id
                                        )
                                      );
                                    }
                                  }}
                                  aria-label={`Selecionar ${marcador.nome || "usuário"
                                    }`}
                                />
                                <span className="usuarios-ui-checkmark" />
                              </label>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={isAdminState ? 5 : 4}>
                        <div className="usuarios-ui-empty">
                          <UserPlus size={30} />
                          <strong>Nenhum usuário encontrado</strong>
                          <span>
                            Tente alterar o termo pesquisado ou verifique os filtros.
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* PAGINAÇÃO */}
            <nav
              className="usuarios-ui-pagination"
              aria-label="Paginação de usuários"
            >
              <button
                type="button"
                className="usuarios-ui-page-button"
                onClick={() => handlePagination(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Página anterior"
              >
                «
              </button>

              {getVisiblePages(currentPage, pages.length).map((page, index) => (
                <span className="usuarios-ui-page-item" key={index}>
                  {page === "..." ? (
                    <span className="usuarios-ui-page-dots">...</span>
                  ) : (
                    <button
                      type="button"
                      className={`usuarios-ui-page-button ${page === currentPage ? "active" : ""
                        }`}
                      onClick={() =>
                        page !== currentPage && handlePagination(page)
                      }
                      aria-current={page === currentPage ? "page" : undefined}
                    >
                      {page}
                    </button>
                  )}
                </span>
              ))}

              <button
                type="button"
                className="usuarios-ui-page-button"
                onClick={() => handlePagination(currentPage + 1)}
                disabled={currentPage === pages.length || pages.length === 0}
                aria-label="Próxima página"
              >
                »
              </button>
            </nav>
          </main>

          {/* EXCLUSÃO EM LOTE */}
          {isAdminState && (
            <div
              className={`usuarios-ui-bulk-actions ${selecionados.length > 0 ? "is-visible" : ""
                }`}
            >
              <span className="usuarios-ui-selected-count">
                <strong>{selecionados.length}</strong>{" "}
                {selecionados.length === 1
                  ? "usuário selecionado"
                  : "usuários selecionados"}
              </span>

              <Tooltip
                title={
                  selecionados.length > 0
                    ? "Excluir usuários selecionados"
                    : "Selecione pelo menos um usuário"
                }
                arrow
                placement="top"
              >
                <span className="usuarios-ui-delete-wrapper">
                  <button
                    type="button"
                    className="usuarios-ui-delete-selected"
                    onClick={excluirSelecionados}
                    disabled={selecionados.length === 0}
                  >
                    <MdDeleteForever size={19} />
                    <span>Excluir selecionados</span>
                  </button>
                </span>
              </Tooltip>
            </div>
          )}

          {/* RODAPÉ */}
          <footer className="usuarios-ui-footer">
            <div className="usuarios-ui-summary">
              <span>
                Total de{" "}
                <strong>
                  {totalItems} {totalItems === 1 ? "usuário" : "usuários"}
                </strong>
              </span>

              <span className="usuarios-ui-divider" />

              <span>
                <strong>{pages.length}</strong>{" "}
                {pages.length === 1 ? "página" : "páginas"}
              </span>
            </div>

            <label className="usuarios-ui-page-size">
              <span>Exibir</span>

              <select
                onChange={limits}
                value={limit}
                aria-label="Quantidade de usuários por página"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value={totalItems}>Todos</option>
              </select>

              <span>por página</span>
            </label>
          </footer>
        </section>
      </div>
    </>
  );

}

export default Usuario;
